<script setup lang="ts">
import { carouselItems } from "@/util/constants";
import { AlarmClockCheckIcon, CheckIcon } from "@gohighlevel/ghl-icons/24/outline";
import {
  UICarousel,
  UITextMdMedium,
  UITextMdNormal,
  UITextSmMedium,
  UITextSmRegular,
} from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-start gap-2.5 self-stretch px-[10px]">
    <div class="flex flex-col items-start gap-[20px] self-stretch">
      <div class="flex items-start gap-2.5 self-stretch">
        <div class="h-[168px] w-[256px]">
          <UICarousel
            :auto-play="true"
            direction="horizontal"
            dot-placement="bottom"
            dot-type="dot"
            class-names="howItWorksCarousel"
            :items-per-view="1"
            :centered-items="true"
            :loop="true"
            :show-dots="true"
            :interval="2000"
            effect="slide"
            :touchable="true"
            :carousel-items="carouselItems"
          >
            <template #customRender>
              <div v-for="item in carouselItems" :key="item.key">
                <img
                  :src="item.src"
                  alt="Category Explain"
                  class="max-h-full max-w-full object-contain"
                />
              </div>
            </template>
          </UICarousel>
        </div>
        <div class="flex flex-col items-start gap-2 self-stretch">
          <div class="flex items-center">
            <UITextSmMedium>{{ t("quiz.category.howItWorks2") }}</UITextSmMedium>
          </div>
          <ol class="m-0 space-y-2 p-0">
            <li class="flex items-center gap-1.5">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-sm font-semibold text-blue-700"
                >1</span
              >
              <UITextSmRegular>{{ t("quiz.category.addCategoryMessage") }}</UITextSmRegular>
            </li>
            <li class="flex items-center gap-1.5">
              <span
                class="flex h-5 w-5 items-center justify-center rounded-full bg-blue-100 text-sm font-semibold text-blue-700"
                >2</span
              >
              <UITextSmRegular>{{ t("quiz.category.assignCategoryMessage") }}</UITextSmRegular>
            </li>
            <li class="flex items-start gap-1.5">
              <span
                class="flex h-5 w-5 items-center justify-center gap-1.5 rounded-full bg-blue-100 text-sm font-semibold text-blue-700"
                >3</span
              >
              <UITextSmRegular>{{ t("quiz.category.editResultsMessage") }}</UITextSmRegular>
            </li>
          </ol>
        </div>
      </div>
      <div class="flex items-start gap-[10px] self-stretch">
        <AlarmClockCheckIcon class="mt-[2px] h-6 w-6 flex-shrink-0"></AlarmClockCheckIcon>
        <section class="mt-1 flex min-w-0 flex-col items-start gap-2 self-stretch">
          <UITextSmMedium>{{ t("quiz.category.useCategoryWhen") }}</UITextSmMedium>
          <ul class="mt-1 flex flex-col gap-2 p-0">
            <li class="flex items-start gap-2">
              <span
                class="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-green-100"
              >
                <CheckIcon class="h-3.5 w-3.5 text-green-500"></CheckIcon>
              </span>
              <UITextMdNormal class="min-w-0 text-gray-600">{{
                t("quiz.category.toEvaluateTheResponder")
              }}</UITextMdNormal>
            </li>
            <li class="flex items-start gap-2">
              <span
                class="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-green-100"
              >
                <CheckIcon class="h-3.5 w-3.5 text-green-500"></CheckIcon>
              </span>
              <UITextMdNormal class="min-w-0 text-gray-600">{{
                t("quiz.category.showMultipleCategoryScore")
              }}</UITextMdNormal>
            </li>
            <li class="flex items-start gap-2">
              <span
                class="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-green-100"
              >
                <CheckIcon class="h-3.5 w-3.5 text-green-500"></CheckIcon>
              </span>
              <UITextMdNormal class="min-w-0 text-gray-600">{{
                t("quiz.category.displayVaryingContent")
              }}</UITextMdNormal>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.howItWorksCarousel {
  border-radius: 8px;
}

.howItWorksCarousel :deep(.n-carousel__dots) {
  bottom: 5px;
}
</style>
